import { useDispatch, useSelector } from 'react-redux';
import { excludeIngredients as excludeIngredientsAction } from '../actions';
import { getIsExcluding, getExcludeError } from '../selectors';

/**
 * Excludes ingredients from the New (Global) Ingredients view.
 *
 * @returns {[excludeIngredients, *, *]}
 */
const useExcludeIngredients = () => {
  const dispatch = useDispatch();
  const isExcluding = useSelector(getIsExcluding);
  const excludeError = useSelector(getExcludeError);

  const excludeIngredients = (itemCodes = []) => {
    if (itemCodes.length === 0) {
      return;
    }
    dispatch(excludeIngredientsAction(itemCodes));
  };

  return [excludeIngredients, isExcluding, excludeError];
};

export default useExcludeIngredients;
